import { render } from "./MessageShow.vue?vue&type=template&id=d43ebcd8&scoped=true&ts=true"
import script from "./MessageShow.vue?vue&type=script&lang=ts"
export * from "./MessageShow.vue?vue&type=script&lang=ts"

import "./MessageShow.vue?vue&type=style&index=0&id=d43ebcd8&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43ebcd8"]])

export default __exports__